import { render } from "./ProjectLogo.vue?vue&type=template&id=5974294a&scoped=true"
import script from "./ProjectLogo.vue?vue&type=script&lang=js"
export * from "./ProjectLogo.vue?vue&type=script&lang=js"

import "./ProjectLogo.vue?vue&type=style&index=0&id=5974294a&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.4.21_webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5974294a"]])

export default __exports__